export default __webpack_public_path__ + "static/media/member.6d4c39c2.svg";